let BASE_URL = process.env.REACT_APP_PHISHING_URL;
let COMPONENT_URL = process.env.REACT_APP_COMPONENT_URL;

if (!BASE_URL || !COMPONENT_URL) {
    const urlhost = window.location.host;
    let ENV = "prod";
    if (urlhost.includes('ev.')) ENV = "dev";
    if (urlhost.includes('tg.'))  ENV = "stg";

    if(!BASE_URL) BASE_URL = `https://api.phishing-manager.${ENV}.venzagrc.com`;
    if(!COMPONENT_URL) COMPONENT_URL = `https://components.${ENV !== "prod" ? 'stg' : 'prod'}.venzapeak.com/venza`;
}

const API_URL = `${BASE_URL}/public`;
export const PDF_URL = `${COMPONENT_URL}/pdfs`;

const ROUTES: Record<string, string> = {
	CAMPAIGN_API: `${API_URL}/campaigns`,
    CAMPAIGN_SUMBIT_STEP_1: `${API_URL}/campaigns/create/step-1`,
    CAMPAIGN_SUMBIT_STEP_2: `${API_URL}/campaigns/create/step-2`,
    CAMPAIGN_SUMBIT_STEP_3: `${API_URL}/campaigns/create/step-3`,
    CAMPAIGN_SUMBIT_STEP_4: `${API_URL}/campaigns/create/step-4`,
    LAUNCH_CAMPAIGN: `${API_URL}/campaigns/create/start-test`,
    TENANT_API: `${API_URL}/tenants`,
    TENANT_USERS_API: `${API_URL}/tenants/users-count`,
    TENANT_THRESHOLD_SUFFIX: `campaigns/threshold-summary`,
    TEMPLATE_API: `${API_URL}/packaged-templates`,
    TEMPLATE_PREVIEW: `${API_URL}/packaged-templates/preview`,
    TEMPLATE_FILTER_API: `${API_URL}/packaged-templates/filters`,
    TIMEZONE_API: `${API_URL}/timezones`,
    RE_RUN_CAMPAIGN: `${API_URL}/campaigns/create/rerun-test`,
    PROPERTIES_API: `${API_URL}/tenants/properties`,
    GROUP_API: `${API_URL}/tenants/property/groups`,
    REPORT_OVERALL_API: `${API_URL}/campaigns/analytics`,
    CORE_METRICS_API: `${API_URL}/campaigns/core-metrics`,
    PROPERTIES_METRICS_API: `${API_URL}/campaigns/property-metrics`,
    INDIVIDUAL_METRICS_API: `${API_URL}/campaigns/report`
}

export default ROUTES